<template>
	<div>
		<el-card class="box-card" shadow="never" v-if="pageset.length>0" v-for="(ite,index) in pageset" :key="index">
			<div slot="header" class="clearfix">
				<span>{{title}}</span>
				<el-button size="mini" v-if="!isdetail" type="success" @click="addrowitem" style="margin-left:10px">{{transportfeelist_lang.addfeeiem}}</el-button>
				<el-button size="mini" type="primary" v-if="copyitem" @click="copyitemto" style="margin-left:10px">{{copyfeetitle}}</el-button>
				<el-button size="mini" type="primary" v-if="createcwlist" @click="createcw" style="margin-left:5px">{{transportfeelist_lang.createcwlist}}</el-button>
				<el-button size="mini" type="warning" v-if="issavefeetemp" @click="savefeetemp" style="margin-left:5px">{{transportfeelist_lang.savefeetemp}}</el-button>
				<el-button size="mini" type="warning" v-if="isimportfeetemp" @click="importfeetemp" style="margin-left:5px">{{transportfeelist_lang.importfeetemp}}</el-button>
			</div>
			<div v-for="(i, idx) in ite.setlist" style="margin-top:-10px">
				<div v-if="i.controltype == 'table'">
					<tableui
						:ref="'feelist_'+item.l_id+'_'+feetype"
						editcell="1"
						:tableData="i[i.colkey]"
						:columns="columns"
						@gridhandle="val => gridhandle(val, i, idx)"
						@autoaddrow="val => gridhandle(val, i, idx)"
						@gridchange="gridchange"
						@checkboxchange="checkboxchange"
						:rowclassname="setrowclass"
						:cellclassname="setcellclass"
					></tableui>
					<el-row v-if="gridsum" style="margin-top:10px">
						<el-col :span="1">
							<span style="color:transparent;">1</span>
						</el-col>
						<el-col :span="22" style="text-align:right;">
								<label v-for="(item,index) in summarylist" class="summary" :key="index"><span class="title">{{item.label}}</span> : <span class="value">{{formatprice(item.value)}}</span> </label>
						</el-col>
						<el-col :span="1">
							<span style="color:transparent;">1</span>
						</el-col>
					</el-row>
				</div>
			</div>
		</el-card>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	props: {
		item: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		isdetail:{
			type:Boolean,
			default:false
		},
		title:{
			type:String,
			default:''
		},
		//显示复制项目按钮
		copyitem:{
			type:Boolean,
			default:false
		},
		//显示生成账单按钮
		createcwlist:{
			type:Boolean,
			default:false
		},
		feetype:{
			type:String,
			default:"1" //1-应付 2-应收
		},
		copyfeetitle:{
			type:String,
			default:'' //复制费用项目标题
		},
		gridsum:{
			type:Boolean,
			default:false
		},
		//是否显示保存账单模板按钮
		issavefeetemp:{
			type:Boolean,
			default:false
		},
		//是否显示导入账单模板按钮
		isimportfeetemp:{
			type:Boolean,
			default:false
		},
	},
	data() {
		return{
			setlist:[],
			transportfeelist_lang:{},
			syscol:'',
			type:'',
			p_mode:'',
			handle: {
				field: '',
				title: '操作',
				type: 'template',
				template: [
					// { type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
					{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
				],
				width: 120,
				sortable: false,
				evttype: 'click',
				colshow: '1',
				event: ''
			},
			orderinfo:'',
			cargorow:{},
			pageset:[],
			checkedrow:[],
			selectedall:false,
			pkval:'',
			sourcemode:'',
			summarylist:[],//{label:'美元',value:20},{label:'人民币',value:200}
			sumarycol:[],
			amount:0,
			t_id:''
			//fixrows:[]
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/transport.scss');
		//this.init();
	},
	methods:{
		init(param){
			//debugger
			this.orderinfo='';
			
			if(param.syscol!=undefined)
				this.syscol=param.syscol;
			if(param.p_mode!=undefined)
				this.p_mode=param.p_mode;
			if(param.type!=undefined)
				this.type=param.type;	
			if(param.orderinfo!=undefined)
				this.orderinfo=param.orderinfo;
			if(param.pkval!=undefined)
				this.pkval=param.pkval;	
			if(param.sumarycol!=undefined)
				this.sumarycol=param.sumarycol;	
			if(param.t_id!=undefined)
				this.t_id=param.t_id;
			this.setlist=[];
			this.loadlanguage();
		},
		formatprice(value){
			if(value!=undefined&&value!=''){
				return value.toFixed(2);
			}
			else
				return (0).toFixed(2);
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('transportfeelist',this).then(res=>{
				if(res.state=='1')
					that.transportfeelist_lang=that.$lang.label.transportfeelist;
				that.getsetlist();
			});
		},
		getsetlist(){
			var that=this;
			//debugger
			this.$apipost.get.GetPagecolSet({syscol:this.syscol,l_mode:this.type+'-'+this.p_mode}).then(res => {
				if(res.length>0){
					var columns=[];
					res.forEach(e=>{
						if(that.transportfeelist_lang[e.showname]!=undefined)
							e.showname=that.transportfeelist_lang[e.showname];
						if(e.controltype=='table'){
							//debugger
							columns=JSON.parse(JSON.stringify(e.table));
						}
					});
					if(columns.length>0){
						if(!that.isdetail){
							 that.handle.index = columns.length + 1;
							 columns.push(that.handle);
						}else{
							columns.forEach(e=>{
								e.type='text';
							});
						}
						columns.forEach(e=>{
							if(that.transportfeelist_lang[e.title]!=undefined)
								e.title=that.transportfeelist_lang[e.title];
						});
					}
					 columns.unshift({field:'checkbox',title:'',type:''});
					 that.columns =columns;
					 this.setlist=res;
					 that.setcargocol(columns);
					 //debugger
					 that.setpagelayout();
				}
			});
		},
		//生成默认行
		setcargocol(colset) {
			var cargo = '';
			colset.forEach(e => {
				if (e.type != 'template'&&e.field!='checkbox') {
					cargo += '"' + e.field + '":"",';
				}
			});
			if (cargo != '') {
				cargo = cargo.substring(0, cargo.length - 1);
			}
			cargo = '[{' + cargo + '}]';
			this.cargorow = JSON.parse(cargo)[0];
		},
		//设置页面数据
		setpagelayout() {
			var that = this;
			this.pageset = [];
			this.pageset.push({ setlist: JSON.parse(JSON.stringify(this.setlist)) });
			
			this.pageset.forEach(e => {
				e.setlist.forEach(s => {
					if (s.controltype == 'table') {
						s[s.colkey] = [];
						//debugger
						if(that.orderinfo[s.colkey]!=undefined)
						{
							if(that.orderinfo[s.colkey].length>0)
								s[s.colkey]=that.orderinfo[s.colkey];
							else
								s[s.colkey].push(JSON.parse(JSON.stringify(that.cargorow)));
						}
						else
							s[s.colkey].push(JSON.parse(JSON.stringify(that.cargorow)));
						if(that.gridsum){
							that.gridSumCol();
						}	
					}
				});
			});
			
		},
		
		//列表操作列
		gridhandle(e, i, index) {
			var that = this;
			if (e.event == 'addrow') {
				that.pageset[0].setlist.forEach(s => {
					if (s.controltype == 'table') {
							//if(!that.isselcargo){
								s[s.colkey].push(JSON.parse(JSON.stringify(that.cargorow)));
								return false;
							//}
					}
				});
			}
			if (e.event == 'delrow') {
				this.$confirm(this.$lang.label.public.deletetips, 
				this.$lang.label.public.remind, {
					confirmButtonText:this.$lang.label.public.sure,
					cancelButtonText: this.$lang.label.public.cancel,
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					that.deleteRow(e, i, index);
					if(that.gridsum){
						that.gridSumCol();
					}
				});
			}
		},
		gridchange(e){
			if(e.event.indexOf('(')>-1){
				var event=e.event;
				event=event.substring(event.indexOf('(')+1,event.length-1);
				//debugger
				if(event.split(',').length>0){
					if(event.split(',')[0]=='num*price'){
						if(!isNaN(e.row.num)&&!isNaN(e.row.price))
							e.row[event.split(',')[1]]=(e.row.num*e.row.price).toFixed(2);
						else
							e.row[event.split(',')[1]]="";
					}
				}
			}
			if(this.gridsum){
				this.gridSumCol();
			}
		},
		gridSumCol(e,checkedrows){
			var that=this;
			var iscount=false;
			
			if(this.sumarycol.triggercols!=undefined&&e!=undefined){
				var list=this.sumarycol.triggercols.filter(function(b){
					return b.toString()==that.columns[e.colindex].field;
				});
				if(list.length>0)
					iscount=true;
			}else
				iscount=true;
				
			if(!iscount)
				return false;
				
			var tablegrid=[];
			if(checkedrows==undefined){
				this.pageset[0].setlist.forEach(e=>{
					if(e.controltype=='table')
						tablegrid=e[e.colkey];
				});
			}
			else
				tablegrid=checkedrows;
				
			if(tablegrid.length>0){
				var sumlist=[];
				var value=0;
				for(var i=0;i<tablegrid.length;i++){
					if(this.sumarycol.cols.length>1)
					{
						var e=tablegrid[i];
						var isgo=true;
						var value2='';
						this.sumarycol.cols.forEach(b=>{
							if(e[b]==''||isNaN(Number(e[b]))){
								isgo=false;
								return false;
							}else{
								if(value2=='')
									value2=Number(e[b]);
								else{
									if(this.sumarycol.counttype=='*')
										value2=value2*Number(e[b]);
									else if(this.sumarycol.counttype=='+')
										value2+=Number(e[b]);
								}
							}
						});
						if(isgo){
							value+=value2;
						}
					}
					else
						value+=Number(tablegrid[i][that.sumarycol.cols[0]]);
				}
				sumlist.push(
				{
					label:that.$lang.label.public.gridSumtitle,
					value:value
				});
				if(checkedrows==undefined){
					this.summarylist=sumlist;
					sumlist.forEach(b=>{
						that.amount=that.amount+Number(b.value);
					});
				}
				else
				{
					var amount=0;
					sumlist.forEach(b=>{
						amount=amount+Number(b.value);
					});
					return amount;
				}
			}
		},
		
		addrowitem(){
			var that=this;
			this.pageset[0].setlist.forEach(s => {
				if (s.controltype == 'table') {
						//if(!that.isselcargo){
							s[s.colkey].push(JSON.parse(JSON.stringify(that.cargorow)));
							return false;
						//}
				}
			});
		},
		addrow(e){
			this.addcargorow(e.rows,undefined,e.isclose);
		},
		//填写行
		addcargorow(rows,i, isclose) {
			//debugger
			var isset=false;
			if (isclose == undefined) isclose = false;
			var that = this;
			var rowindex = this.gridrowindex;
			if(i!=undefined){
				//判断新添加的商品是否已存在在已添加列表中，有则累加数量，没有则新增行
				i[i.colkey].forEach(e => {
					var index = 0;
					rows.forEach(r => {
						if (r.id == e.id && e.id != '') {
							e.num = parseInt(e.num) + 1;
							//移除此行
							rows.splice(index, 1);
						}
						index++;
					});
				});
				rows.forEach(e => {
					if (rowindex > that.gridrowindex) i[i.colkey].splice(rowindex, 0, JSON.parse(JSON.stringify(this.cargorow)));
					for (var key in i[i.colkey][rowindex]) {
						for (var cargokey in e) {
							if (cargokey == key) {
								i[i.colkey][rowindex][key] = e[key];
								break;
							}
						}
						if (key == 'num'&&i[i.colkey][rowindex][key]=='') i[i.colkey][rowindex][key] = '1';
					}
					rowindex++;
				});
			}
			else{
				that.pageset.forEach(p=>{
					p.setlist.forEach(s=>{
						if(s.controltype=='table')
						{
							s[s.colkey].forEach(e => {
								var index = 0;
								rows.forEach(r => {
									if (r.id == e.id && e.id != '') {
										e.num = parseInt(e.num) + 1;
										//移除此行
										rows.splice(index, 1);
									}
									index++;
								});
							});
							rows.forEach(e => {
								if (rowindex > that.gridrowindex) s[s.colkey].splice(rowindex, 0, JSON.parse(JSON.stringify(that.cargorow)));
								for (var key in s[s.colkey][rowindex]) {
									for (var cargokey in e) {
										if (cargokey == key) {
											s[s.colkey][rowindex][key] = e[key];
											break;
										}
									}
									if (key == 'num'&&s[s.colkey][rowindex][key]=='') s[s.colkey][rowindex][key] = '1';
								}
								rowindex++;
							});
							isset=true;
							return false;
						}
					});
					if(isset)
						return false;
				});
			}
			if (isclose) this.closecargo();
			else {
				if (rows.length > 0) {
					this.$refs.cargo[0].setfoucsbyindex(this.gridrowindex, undefined, 'num');
				}
			}
			this.$emit('addedcallback', {
				gridrowindex:this.gridrowindex
			});
		},
		deleteRow(e, i, index) {
			i[i.colkey].splice(e.index, 1);
			if (i[i.colkey].length < 1) {
				i[i.colkey].push(JSON.parse(JSON.stringify(this.cargorow)));
			}
		},
		checkboxchange(e){
			//debugger
			if (!e.selectedall) {
				this.selectedall=false;
				this.checkedrow = e.rows; 
			}else
				this.selectedall=true;
		},
		//复制项目
		copyitemto(){
			var feelist=[];
			//debugger
			if(this.selectedall){
				this.pageset.forEach(e => {
					e.setlist.forEach(s => {
						if (s.controltype == 'table') {
							feelist=s[s.colkey];
						}
					});
				});
			}else
				feelist=this.checkedrow;	
			if(feelist.length>0){
				var list=JSON.parse(JSON.stringify(feelist));
				list.forEach(e=>{
					e.spec="";//代表财务账单编号
					delete e.index;
					delete e.isedit;
				})
				this.$emit('feehandler',{event:'copy',feelist:list,type:this.feetype});
			}
			else
				this.$tool.message(this.transportfeelist_lang.nocheckedfeelist, "2");
		},
		//表单填充
		fillfeelist(list){
			//debugger
			this.pageset.forEach(e => {
				e.setlist.forEach(s => {
					if (s.controltype == 'table') {
						list.forEach(b=>{
							s[s.colkey].unshift(b);
						});
						return false;
					}
				});
			});
			if(this.gridsum){
				this.gridSumCol();
			}
		},
		//生成财务账单
		createcw(){
			//debugger
			var feelist=[];
			//debugger
			if(this.selectedall){
				this.pageset.forEach(e => {
					e.setlist.forEach(s => {
						if (s.controltype == 'table') {
							feelist=s[s.colkey];
						}
					});
				});
			}else
				feelist=this.checkedrow;	
			//debugger
			if(feelist.length>0)
			{
				var list=feelist.filter(function(e){
					return e.spec!=undefined&&e.spec!='';
				});
				if(list.length>0){
					this.$tool.message(this.transportfeelist_lang.feelistiscreatecw, "2");
				}else{
					feelist.forEach(e=>{
						e.cname=e.ename;
						e.p_payitem=e.brand;
						e.amount=e.price;
						if(e.p_pkval!=undefined)
							delete e.p_pkval;
					});
					const map = new Map();
					feelist.forEach(item => map.get(item.cname) ? map.get(item.cname).push(item) : map.set(item.cname,[item]));
					var list=[];
					for(let item of map){
					   list.push({key:item[0],value:item[1]});
					}
					//debugger
					this.createCwBill(list,0);
				}				
			}
			else
				this.$tool.message(this.transportfeelist_lang.nocheckedfeelist, "2");
		},
		createCwBill(list,index){
			var that=this;
			if(list.length>index){
				var t_id='cw_6'; //应付
				if(this.feetype==2)//应收
					t_id='cw_7';
				var billid=new Date().getTime();
				var paraminfo = {
					p_bagid:this.pkval,
					p_sys:this.type,
					p_cicc:'p_pkval',
					cgname:list[index].key,
					p_pkval:billid,
					t_id:t_id,
					list:list[index].value,
					u_userid: localStorage.getItem('userid')
				};
				//debugger
				//console.log('保存',JSON.stringify(paraminfo));
				//return false;
			//	debugger
				this.$tool.loading(this.$lang.label.public.saving, this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					//debugger
					if (res.state == '1') {
						//账单号回填到表格
						that.setgridcwbill(JSON.parse(JSON.stringify(list[index].value)),res.pkval);
						index=parseInt(index)+1;
						that.createCwBill(list,index);
					} else {
						index=parseInt(list.length)+1;
						this.$tool.message(res.message, 0);
					}
				});
			}
			else
			{
				if(index==list.length)
					this.$tool.message(that.$lang.label.public.savesuccess, 1);
			}
		},
		setrowclass({row, rowIndex}){
			//debugger
			row.index=rowIndex;
		},
		setcellclass({row, column, rowIndex, columnIndex}){
			//debugger
			if(row.spec!=''&&row.spec!=undefined&&(columnIndex>0))
			{
				this.$set(row,'isedit',true);
				//debugger
				return 'inputdisabled';
			}
		},
		setgridcwbill(list,billid){
			//debugger
			var that=this;
			this.pageset.forEach(e => {
				e.setlist.forEach(s => {
					if (s.controltype == 'table') {
						//var rowindex=0;
						s[s.colkey].forEach(b=>{
							list.forEach(i=>{
								//debugger
								if(b.index==i.index)
								{
									b.spec=billid;
									this.$set(b,'isedit',true);
									return false;
								}
							});
						})
					}
				});
			});
			//debugger
		},
		savefeetemp(){
			debugger			
			var that=this;
			var feelist=[];
			var feetype='应付';
			this.pageset.forEach(e => {
				e.setlist.forEach(s => {
					if (s.controltype == 'table') {
						feelist=s[s.colkey];
					}
				});
			});
			var isempty=true;
			if(this.feetype==2)
				feetype='应收';
			if(feelist.length>0){
				feelist.forEach(e=>{
					e.p_sort=feetype;
				});
				//debugger
				for(var i=0;i<feelist.length;i++){
					for(var j in feelist[i]){
						if(feelist[i][j]!="")
						{
							isempty=false;
							break;
						}
					}
					if(isempty)
						return false;
				}
			}
			if(feelist.length>0&&!isempty){
				var param={
					p_sys:this.type+'-'+this.p_mode,
					feelist:feelist,
					dialogtitle:this.transportfeelist_lang.savefeetemp
				};
				this.$public.savefeetemp(this,param);
			}
		},
		importfeetemp(){
			var param={
				p_sys:this.type+'-'+this.p_mode,
				feetype:this.feetype,
				dialogtitle:this.transportfeelist_lang.importfeetemp
			};
			this.$tool.loading(this.$lang.label.public.loading, this.divclass);
			this.$public.importfeetemp(this,param);
		},
		feecallback(param){
			//debugger
			if(param.type==1){//表示覆盖原来的
				this.pageset.forEach(e => {
					e.setlist.forEach(s => {
						if (s.controltype == 'table') {
							s[s.colkey]=[];
							return false;
						}
					});
				});
				this.fillfeelist(param.feelist);
			}
			else {//在原来的上面累加
				this.fillfeelist(param.feelist);
			}
		}
	},
}
</script>

<style>
</style>